import { Auth } from "aws-amplify";
import {
  BETA_GRAPHQL_ENDPOINT,
  GAMMA_GRAPHQL_ENDPOINT,
  PROD_GRAPHQL_ENDPOINT,
} from "../constants/urlConstants";

const getAuthorizationHeader = async () => ({
  Authorization: (await Auth.currentAuthenticatedUser())
    .getSignInUserSession()
    .getIdToken()
    .getJwtToken(),
});
const oauthCommon = Object.freeze({
  domain:
    "federate-tpsstaffaugmentationservice-beta.auth.us-west-2.amazoncognito.com",
  scope: ["email", "openid", "phone"],
  responseType: "code",
  redirectSignIn: "https://beta-pdx.selfservice.security.amazon.dev",
  redirectSignOut: "https://beta-pdx.selfservice.security.amazon.dev",
});

const amplifyCommon: any = Object.freeze({
  authenticationFlowType: "USER_SRP_AUTH",
  aws_appsync_region: "us-west-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
});

const amplifyBeta: any = Object.freeze({
  Auth: {
    mandatorySignId: true,
    region: "us-west-2",
    userPoolId: "us-west-2_q9qEMOnsb",
    userPoolWebClientId: "7skdaalgavaavpcrcg2htrrr5q",
  },
  oauth: {
    ...oauthCommon,
  },
  aws_appsync_graphqlEndpoint: BETA_GRAPHQL_ENDPOINT,
  API: {
    graphql_endpoint: BETA_GRAPHQL_ENDPOINT,
    region: "us-west-2",
    defaultAuthMode: "userPool",
    graphql_headers: getAuthorizationHeader,
  },
  ...amplifyCommon,
});

const amplifyGamma = Object.freeze({
  Auth: {
    mandatorySignId: true,
    region: "us-west-2",
    userPoolId: "us-west-2_pewxEB7LP",
    userPoolWebClientId: "22516bgq6tm1gaob6c7mgms9p",
  },
  oauth: {
    ...oauthCommon,
  },
  aws_appsync_graphqlEndpoint: GAMMA_GRAPHQL_ENDPOINT,
  API: {
    graphql_endpoint: GAMMA_GRAPHQL_ENDPOINT,
    graphql_headers: getAuthorizationHeader,
  },
  ...amplifyCommon,
});

const amplifyProd = Object.freeze({
  Auth: {
    mandatorySignId: true,
    region: "us-west-2",
    userPoolId: "us-west-2_jZJRI9qMd",
    userPoolWebClientId: "5l01novhlun9k1ntsol1vm4o91",
  },
  oauth: {
    ...oauthCommon,
  },
  aws_appsync_graphqlEndpoint: PROD_GRAPHQL_ENDPOINT,
  API: {
    graphql_endpoint: PROD_GRAPHQL_ENDPOINT,
    graphql_headers: getAuthorizationHeader,
  },
  ...amplifyCommon,
});

export function getAmplifyConfiguration(stage: string): any {
  switch (stage) {
    case "beta":
      return amplifyBeta;
    case "gamma":
      return amplifyGamma;
    case "prod":
    default:
      return amplifyProd;
  }
}

export default getAmplifyConfiguration;
